import React, { Component, Fragment } from "react";

import { inject, observer } from "mobx-react";
import { Link, withRouter } from "react-router-dom";
// import NumberFormat from "react-number-format";
// import moment from "moment";
import { BookingStatusType, ProfileType, BookingType, LineupStatusType, RosterDividendType } from "../../types/enum";
import "./BookingDetails.css";
import { Grid, Typography, Button, Menu, MenuItem, Snackbar, IconButton, CircularProgress } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ResponsiveTable from "../table/ResponsiveTable";
import BookingChangeActModal from "./BookingModal/BookingChangeActModal";
import BookingStatusBadge from "./BookingStatusBadge";
import Loading from "../loadingSpinner/Loading";
import moment from "moment";
import ConfirmationModal from "../modal/ConfirmationModal";
import currencyHelper from '../../helper/currency';
import CheckCircle from "@material-ui/icons/CheckCircle";
import DirectionsIcon from "@material-ui/icons/Directions";
import VisibilityIcon from "@material-ui/icons/Visibility";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Cancel";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import PrintIcon from "@material-ui/icons/Print";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import GetAppIcon from "@material-ui/icons/GetApp";
import Tooltip from "@material-ui/core/Tooltip";
import bookingCalculationHelper from "../../helper/bookingCalculationHelper"
import BulkEditModal from "./BulkEditModal"
import BulkCancelModal from "./BulkCancelModal"
import agent from "../../agent"

const BOOKING_STATUS = [
    "New",
    "Declined",
    "Negotiate",
    "Accepted",
    "LineupSet",
    "SetlistSet",
    "Ready",
    "Completed",
    "Paid",
    "Cancelled",
    "Resent",
    "Draft",
    "Incomplete",
    "Cancelled By Act",
    "Cancelled By Act",
    "SentToAct",
    "PlayerNotified",
    "PlayerDeclined",
    "AllPlayerConfirmed",
    "ClientNotified",
    "PlayerInvitedAndClientNotified",
    "PlayerConfirmedAndClientNotified"
];

@inject("profileStore", "bookingRequestStore", "templateStore", "reportStore")
@withRouter
@observer
class   BookingRequests extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancelBookingModalState: false,
            declineBookingModalState: false,
            columns: [],
            changeActModalState: false,
            booking: undefined,
            actionAnchor: [],
            isLoading: false,
            duplicateModalState: true,
            duplicateModalState: null,
            openDuplicateSnackbar: false,
            duplicateBooking: undefined,
            deleteModalState: false,
            openDeleteSnackbar: false,
            deleteBooking: undefined,
            page: 1,
            cancelModalState: false, 
            cancelBooking: undefined,
            selectedBookings: [],
            bulkEditModalOpen: false,
            bulkCancelModalOpen: false,
            isExporting: false
        };

        this.row = [];
    }
    
    setActionAnchor = (element, bookingId) => {
        var tempAnchor = [];
        tempAnchor[bookingId] = element;
        this.setState({ ...this.state, actionAnchor: tempAnchor });
    };

    unsetActionAchnor = bookingId => {
        this.setState({ ...this.state, actionAnchor: [] });
    };

    componentDidMount() {
        
        if (this.props.profileType === "agent") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date/Time", width: "12%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "venue", label: "Venue", width: "14%" },
                    { key: "actName", label: "Act Name", width: "14%" },
                    { key: "status", label: "Status", width: "10%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                    { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "agentFee", label: <Tooltip title="Agent Fee"><span>Agent Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "actFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "superFee", label: <Tooltip title="Superannuation Fee"><span>Super Fee</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "action", label: "Actions", width: "7%" }
                ]
            });
        } else if (this.props.profileType === "musician") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date/Time", width: "12%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "venue", label: "Venue", width: "14%" },
                    { key: "actName", label: "Act Name", width: "14%" },
                    { key: "status", label: "Status", width: "10%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                    { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, isNumber: true, width: "9%", align: 'left', style: { flexDirection: 'row' } },
                    { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "9%", align: 'left', style: { flexDirection: 'row' } },
                    { key: "myFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, sortable: true, isNumber: true, width: "9%", align: 'left', style: { flexDirection: 'row' } },
                    { key: "superFee", label: "Super Fee", sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "action", label: "Actions", width: "7%" }
                ]
            });
        } else if (this.props.profileType === "staff") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date", width: "15%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "status", label: "Status", width: "15%" },
                    { key: "actName", label: "Act Name", width: "15%" },
                    { key: "venue", label: "Venue", width: "15%" },
                    { key: "gigFee", label: "Gig Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } }, 
                    { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                    { key: "actFee", label: "Performance Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                    // { key: "acknowledge", label: "", width: "15%" },
                    { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                    { key: "action", label: "", width: "15%" }
                ]
            });
        }
    }

    loadGigsRequests = (page) => {
        const {
            currentProfile
        } = this.props.profileStore;
        this.props.bookingRequestStore.showLoadingState()
        Promise.all([
            this.props.bookingRequestStore.loadGigsRequests(currentProfile?.id,page),
        ]).then(() => {
            this.setState({
                ...this.state,
                isLoading: false
            });
            this.props.bookingRequestStore.hideLoadingState();
            this.props.bookingRequestStore.setDraftPage(page)
        });
    }
    handleShowMore = e => {
        var page = parseInt(this.props.bookingRequestStore.draftPage) + 1;
        this.loadGigsRequests(page)
    };
    handleAcceptBooking = e => {
        const { currentProfile } = this.props.profileStore;
        this.props.bookingRequestStore.saveStatus(currentProfile?.id, BookingStatusType.Accepted.ordinal).then(() => {
            this.props.templateStore.openSnackbar("Booking accepted!");
            this.props.templateStore.setEditMusicianBookingActiveStep(2); // skip negotiate
        });
    };

    handleHoldBooking = e => {
        const { currentProfile } = this.props.profileStore;
        this.props.bookingRequestStore.saveStatus(currentProfile?.id, BookingStatusType.Hold.ordinal).then(() => {
            this.props.templateStore.openSnackbar("Booking hold!");
            this.props.templateStore.setEditMusicianBookingActiveStep(1);
        });
    };

    handleDeclineBooking = e => {
        const { currentProfile } = this.props.profileStore;
        this.props.bookingRequestStore.saveStatus(currentProfile?.id, BookingStatusType.Declined.ordinal).then(() => {
            this.props.templateStore.openSnackbar("Booking declined!");
            this.props.templateStore.setEditMusicianBookingActiveStep(2); // skip negotiate
        });
    };

    handleOpenCancelModal = () => this.setState({ cancelBookingModalState: true });
    handleCloseCancelModal = () => this.setState({ cancelBookingModalState: false });

    handleOpenDeclineModal = () => this.setState({ declineBookingModalState: true });
    handleCloseDeclineModal = () => this.setState({ declineBookingModalState: false });
    
    handleSendReminder = booking => {
        this.props.bookingRequestStore.handleSendReminder(booking.id).then(() => {
            this.unsetActionAchnor()
            this.props.templateStore.openSnackbar("Booking request reminder sent");
        })
        
    }

    handleSendReminderRequest = booking => {
        this.props.bookingRequestStore.handleSendReminderRequest(booking.id).then(() => {
            this.unsetActionAchnor()
            this.props.templateStore.openSnackbar("Booking request reminder sent");
        })
        
    }
    
    handleOpenChangeActModal = booking => this.setState({ changeActModalState: true, booking: booking, actionAnchor: [] });
    handleCloseChangeActModal = () => {
        const { currentProfile } = this.props.profileStore;
        this.setState({
            ...this.state,
            isLoading: true
        });
        this.props.bookingRequestStore.resetRequestGigs()
        this.props.bookingRequestStore.loadGigsRequests(currentProfile?.id,1).then(() => {
            this.setState({
                ...this.state,
                isLoading: false,
                changeActModalState: false
            });
        });
    };

    handleCloseChangeActModalWithoutAction = () => {
        const { currentProfile } = this.props.profileStore;
        this.setState({
            ...this.state,
            isLoading: false,
            changeActModalState: false
        });
    };

    handleOpenDuplicateBookingModal = booking => this.setState({ duplicateModalState: true, duplicateBooking: booking, actionAnchor: [] });
    handleCloseDuplicateBookingModal = () => {
        this.setState({
            ...this.state,
            duplicateModalState: false,
            duplicateBooking: null
        });
    };
    handleDupicateRequest = () => {
        const { duplicateBooking } = this.state;
        const bookingRequestId = duplicateBooking?.bookingRequests?.filter(x => !x.deleted)[0]?.id || 0;

        this.props.bookingRequestStore.getDetailBookingCalendar(duplicateBooking.id, bookingRequestId)
            .then(() => {
                const freshBooking = this.props.bookingRequestStore.bookingDetail;
                this.props.bookingRequestStore.setDuplicateBooking(freshBooking);

                this.props.history.push(
                    `/booking/new?actId=${freshBooking?.actId ? freshBooking?.actId : "undefined"}&duplicateBooking=${true}&venueId=${freshBooking?.venueId ? freshBooking?.venueId : "undefined"}&dateStart=${freshBooking?.dateStart ? moment(freshBooking?.dateStart, "DD-MM-YYYY").add(1, "days").format("DD-MM-YYYY") : moment(new Date()).format("DD-MM-YYYY")}`,
                    { from: 'fromBookingStation' }
                );
                this.handleCloseDuplicateBookingModal();
                this.setState({ openDuplicateSnackbar: true });
            });
    };

    handleSnackbarEditClose = (event, reason) => {
        this.setState({ openDuplicateSnackbar: false });
    };

    
    handleCancelBooking = e => {
        const { currentProfile } = this.props.profileStore;
        var bookingId = this.state.cancelBooking.id
        this.props.bookingRequestStore.saveStatusBooking(currentProfile?.id, BookingStatusType.Cancelled.ordinal,this.state.cancelBooking).then(() => {
            this.props.templateStore.openSnackbar("Booking cancelled!"); // skip negotiate
            this.props.bookingRequestStore.filterDeleteRequest(bookingId)  
        });
        this.handleCloseCancelBookingModal() 
    };

    getBookingStatus = booking => {
        const { currentProfile } = this.props.profileStore;
        const isAgent = currentProfile && currentProfile?.type === ProfileType.Agent.ordinal;
        const isStaff = currentProfile && currentProfile?.type === ProfileType.Staff.ordinal;
        const isStaffOrAgent = isStaff || isAgent;
        const isBookingCreator = booking.createdById === currentProfile?.id;

        if (booking.status === BookingStatusType.New.ordinal && booking.saveAsDraft) {
            return "Draft";
        }
        if (booking.status === BookingStatusType.New.ordinal && booking.notifyAct && currentProfile?.type === ProfileType.Agent.ordinal) {
            if (!isBookingCreator && booking.isAdmin) {
                return "New"
            } else {
                return "SentToAct";
            }
        }
        if (booking.status === BookingStatusType.New.ordinal && !booking.saveAsDraft && isStaffOrAgent) {
            return "Sent";
        }

        return BOOKING_STATUS[booking.status];
    };

    handleOpenDeleteBookingModal = booking => this.setState({ deleteModalState: true, deleteBooking: booking, actionAnchor: [] });
    handleCloseDeleteBookingModal = () => {
        this.setState({
            ...this.state,
            deleteModalState: false,
            deleteBooking: null
        });
    };

    handleOpenCancelBookingModal = booking => {
        this.setState({ cancelModalState: true, cancelBooking: booking, actionAnchor: [] });
    }
    handleCloseCancelBookingModal = () => {
        this.setState({
            ...this.state,
            cancelModalState: false,
            cancelBooking: null
        });
    };
    handleDeleteRequest = () => {
        const { deleteBooking } = this.state;
        const {currentProfile} = this.props.profileStore
        this.props.bookingRequestStore.deleteBooking(deleteBooking.id, currentProfile.id).then(response => {
            this.handleCloseDeleteBookingModal();
           
            this.setState({ openDeleteSnackbar: true});
            this.props.bookingRequestStore.filterDeleteRequest(deleteBooking.id)
        });
    };

    handleSnackbarDeleteClose = (event, reason) => {
        this.setState({ openDeleteSnackbar: false });
    };

    getCheckedRows = rows => {
        this.setState({ selectedBookings: rows });
    };

    openBulkEditModal = () => {
        this.setState({ bulkEditModalOpen: true });
    };

    closeBulkEditModal = () => {
        this.setState({ bulkEditModalOpen: false });
    };

    openBulkCancelModal = () => {
        this.setState({ bulkCancelModalOpen: true });
    };

    closeBulkCancelModal = () => {
        this.setState({ bulkCancelModalOpen: false });
    };

    handleBulkCancelComplete = () => {
        this.setState({ selectedBookings: [] });
    };

    handleBulkEditSubmit = async (selectedRows, updates) => {
        const { currentProfile } = this.props.profileStore;
        
        try {
            const result = await this.props.bookingRequestStore.bulkUpdateBookings(selectedRows, updates, true, currentProfile?.id);

            this.setState({ selectedBookings: [] });
            
            return result;
        } catch (error) {
            console.error("Bulk edit error:", error);
            throw error;
        }
    };

    exportToCSV = () => {
        const { selectedBookings } = this.state;
        const { requests } = this.props.bookingRequestStore;
        const { venueId } = this.props.reportStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        
        this.setState({ isExporting: true });
        
        try {
            const selectedIds = selectedBookings.map(row => row.id);
            const originalBookings = requests.filter(booking => selectedIds.includes(booking.id));
            
            const data = originalBookings.map(booking => {
                const collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile);
                const venueName = booking.venueName || booking.venue?.profileName || "";
                const venueAddress = booking.venue?.street1 
                    ? `${booking.venue.street1}${booking.venue.city ? ', ' + booking.venue.city : ''}${booking.venue.state ? ', ' + booking.venue.state : ''}`
                    : "";
                
                return {
                    date: moment(booking.dateStart).format("DD/MM/YYYY"),
                    timeStart: moment(booking.timeStart, "HH:mm:ss").format("hh:mm A"),
                    timeEnd: moment(booking.timeEnd, "HH:mm:ss").format("hh:mm A"),
                    venueName: venueName,
                    venueAddress: venueAddress,
                    actName: booking.actName || booking.act?.actName || "",
                    status: this.getBookingStatus(booking),
                    venueClientFee: parseFloat(collectedFee.gigFee || 0).toFixed(2),
                    agentFee: parseFloat(collectedFee.agentFeeNumber || 0).toFixed(2),
                    performanceFee: parseFloat(collectedFee.performanceFee || booking.actFee || 0).toFixed(2),
                    invoiceAmount: parseFloat(collectedFee.feePaidToActNumber || 0).toFixed(2)
                };
            });

            const headers = ["Date", "Time Start", "Time End", "Venue Name", "Venue Address", "Act Name", "Status", "Venue/Client Fee", "Agent Fee", "Performance Fee", "Invoice Amount"];
            
            const csvContent = [
                headers.join(","),
                ...data.map(row => [
                    `"${row.date}"`,
                    `"${row.timeStart}"`,
                    `"${row.timeEnd}"`,
                    `"${row.venueName.replace(/"/g, '""')}"`,
                    `"${row.venueAddress.replace(/"/g, '""')}"`,
                    `"${row.actName.replace(/"/g, '""')}"`,
                    `"${row.status}"`,
                    row.venueClientFee,
                    row.agentFee,
                    row.performanceFee,
                    row.invoiceAmount
                ].join(","))
            ].join("\n");

            const agencyName = currentProfile?.profileName || "Agency";
            
            let venueLabel = "All Venues";
            if (venueId && originalBookings.length > 0) {
                const firstBooking = originalBookings[0];
                venueLabel = firstBooking.venueName || firstBooking.venue?.profileName || "All Venues";
            }
            
            const sanitizedAgencyName = agencyName.replace(/[^a-zA-Z0-9]/g, '_');
            const sanitizedVenueLabel = venueLabel.replace(/[^a-zA-Z0-9]/g, '_');
            const dateStr = moment().format("YYYY-MM-DD");
            const fileName = `booking_requests_${sanitizedAgencyName}_${sanitizedVenueLabel}_${dateStr}.csv`;

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            this.props.templateStore.openSnackbar(`Successfully exported ${originalBookings.length} booking(s) to CSV`);
        } catch (error) {
            console.error("CSV export error:", error);
            this.props.templateStore.openSnackbar("Error exporting to CSV. Please try again.");
        } finally {
            this.setState({ isExporting: false });
        }
    };

    isRelatedCreator = (booking) => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        if (!currentProfile) return false;
        return currentProfile.id === booking.createdById || (booking.relatedCreatorId && booking.relatedCreatorId.includes(String(currentProfile.id)));
    };

    renderTableCustomActions = () => {
        const { selectedBookings, isExporting } = this.state;
        const isDisabled = !selectedBookings || selectedBookings.length === 0;
        const hasNonCreator = !isDisabled && selectedBookings.some(row => {
            const booking = this.props.bookingRequestStore.newRequests.find(b => b.id === row.id);
            return !booking || !this.isRelatedCreator(booking);
        });
        const isBulkDisabled = isDisabled || hasNonCreator;
        const isBulkEditDisabled = isBulkDisabled || selectedBookings.length > 40;
        const isBulkCancelDisabled = isBulkDisabled || selectedBookings.length > 40;
        return (
            <Fragment>
                <Button 
                    onClick={this.openBulkEditModal} 
                    disabled={isBulkEditDisabled} 
                    style={{ color: !isBulkEditDisabled ? "#fff" : undefined }}
                >
                    <EditIcon style={{ color: !isBulkEditDisabled ? "#fff" : undefined, marginRight: 4 }} />
                    Bulk Edit
                </Button>
                <Button 
                    onClick={this.openBulkCancelModal} 
                    disabled={isBulkCancelDisabled} 
                    style={{ color: !isBulkCancelDisabled ? "#fff" : undefined }}
                >
                    <CancelIcon style={{ color: !isBulkCancelDisabled ? "#fff" : undefined, marginRight: 4 }} />
                    Bulk Cancel
                </Button>
                {selectedBookings.length > 40 && (
                    <span style={{ color: "#e65100", fontSize: 13, fontWeight: 500, marginLeft: 8, alignSelf: "center" }}>
                        &#9888; Bulk actions are limited to 40 bookings. Please deselect some.
                    </span>
                )}
                <Button 
                    onClick={this.exportToCSV} 
                    disabled={isDisabled || isExporting} 
                    style={{ color: !isDisabled && !isExporting ? "#fff" : undefined, marginLeft: 8 }}
                >
                    {isExporting ? (
                        <CircularProgress size={20} style={{ color: "#fff", marginRight: 4 }} />
                    ) : (
                        <GetAppIcon style={{ color: !isDisabled ? "#fff" : undefined, marginRight: 4 }} />
                    )}
                    {isExporting ? "Exporting..." : "Download CSV"}
                </Button>
            </Fragment>
        );
    };

    renderFooterRow = () => {
        let { requests } = this.props.bookingRequestStore;
        const { profileType } = this.props;
        const { venueId } = this.props.reportStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        
        if (venueId) {
            requests = requests.filter(x => x.venueId === venueId);            
        }
        var totalFee = 0;
        var totalActFee = 0;
        var totalAgentFee = 0;
        var totalMyFee = 0
        var filterRequest = requests.filter(x => !x.saveAsDraft && (x.notifyAct || x.notifyAgent || x.notifyClient) && x.status !== BookingStatusType.Draft.ordinal);
                
        filterRequest.forEach(booking => {
            let linuep = booking?.lineups?.find(x => x.profileId === currentProfile?.id);
            var musicianFee = parseFloat(booking.gigFee) - totalFee
            const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;

            let adminFeeRoster = 0
            let totalRosterFeeAdmin = 0
            booking?.act?.actRoster?.forEach(actRoster => {
                let feeCount = 0
                if(actRoster.dividendType === RosterDividendType.Percentage.ordinal){
                    feeCount = actRoster.dividendAmount /100 * booking.actFee;
                }else {
                    feeCount = actRoster.dividendAmount;
                }
                totalRosterFeeAdmin = totalRosterFeeAdmin + feeCount
            })
            adminFeeRoster = booking.actFee - totalRosterFeeAdmin
            if(currentProfile?.type === ProfileType.Musician.ordinal && !booking?.lineups?.length){
                let actRoster = booking?.act?.actRoster?.filter(x => x.rosters.some(t => t.profileId === currentProfile?.id));
               
                if(actRoster?.length){
                    if(actRoster[0].dividendType === RosterDividendType.Percentage.ordinal){
                        musicianFee = actRoster[0].dividendAmount /100 * booking.actFee;
                    }else {
                        musicianFee = actRoster[0].dividendAmount;
                    }
                    if(this.props.profileType === 'musician'){
                        if(booking?.act?.actAdminId === currentProfile?.id){
                            musicianFee = parseFloat(musicianFee) + parseFloat(adminFeeRoster)
                        }
                    }
                }else{
                    musicianFee = booking.actFee
                    booking?.act?.actRoster?.forEach(item => {
                        var rosterFee = 0
                        if(item.dividendType === RosterDividendType.Percentage.ordinal){
                            rosterFee = item.dividendAmount /100 * booking.actFee;
                        }else {
                            rosterFee = item.dividendAmount;
                        }
                        musicianFee = musicianFee - rosterFee
                    });
                }
            }
             
            var totalRosterFee = 0

            booking?.lineups?.forEach(lineUp => {
                totalRosterFee = parseFloat(totalRosterFee) + parseFloat(lineUp.fee) 
            })
            var adminFee = booking.actFee - totalRosterFee
            var calculateFee = linuep?.fee ?  linuep?.fee : 0
            if(this.props.profileType === 'musician'){
                if(booking?.act?.actAdminId === currentProfile?.id){
                    calculateFee = parseFloat(calculateFee) + parseFloat(adminFee)
                }
            }
            
            let myFee = linuep?.fee ? calculateFee: isEntertainerBookings ? booking.gigFee : (booking.isAdmin && !linuep) ? musicianFee : booking.actFee;
          
            let actOwner = booking.act?.userId === currentProfile?.userId;
            let agentActOwner = currentProfile?.type === ProfileType.Agent.ordinal && booking.createdById !== currentProfile?.id && booking.act.actAdminId === currentProfile?.id;
            let totalLineupFee = 0

            totalFee += (booking.viewOnly) ? 0 : (profileType === "agent" || profileType === "staff") && booking.isApproved ? Number(booking.gigFee) + Number(booking.extraGigFee) : Number(booking.gigFee);
            // totalActFee += this.props.profileType === "musician" && !actOwner ? 0 : Number(booking.actFee);
            totalActFee += agentActOwner ? 0 : this.props.profileType === "musician" && !actOwner ? 0 : Number(booking.actFee);
            totalMyFee += Number(myFee);
            booking?.lineups?.forEach(l => {
                if (l.status !== LineupStatusType.Removed.ordinal) {
                    totalLineupFee += parseFloat(l.fee)
                }                                    
            }); 
            totalAgentFee += agentActOwner ? parseFloat(booking.actFee) - parseFloat(totalLineupFee) :  Number(booking.agentCommissionAmount);
        });
        
        return {
            gigFee: ( (currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalFee, 2)}`,
            actFee: ( (currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalActFee, 2)}`,
            agentCommissionAmount: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalAgentFee, 2)}`, 
            agentFee: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalAgentFee, 2)}`, 
            myFee: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalMyFee, 2)}`,
            style: {
                textAlign: 'left'
            }
        }
    }

    renderMobileGigCard = (row, index) => {
        return (
            <div key={index} className="mobile-gig-card" style={row.style}>
                <div className="mobile-gig-card-header">
                    {row.date?.newFormat}
                    <div className="mobile-gig-card-venue">
                        {row.venue}
                    </div>
                </div>
                <div className="mobile-gig-card-fees">
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Venue/Client Fee</span>
                        <span className="mobile-gig-fee-value">{row.gigFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Agent Fee</span>
                        <span className="mobile-gig-fee-value">{row.agentCommissionAmount}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Performance Fee</span>
                        <span className="mobile-gig-fee-value">{row.myFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Invoice Amount</span>
                        <span className="mobile-gig-fee-value">{row.feePaidToAct}</span>
                    </div>
                </div>
                <div className="mobile-gig-card-footer">
                    <div className="mobile-gig-card-act">
                        <div className="mobile-gig-card-status">{row.status}</div>
                        {row.actName}
                    </div>
                    <div className="mobile-gig-card-actions">
                        {row.action}
                    </div>
                </div>
            </div>
        );
    }

    renderAgentMobileGigCard = (row, index) => {
        return (
            <div key={index} className="mobile-gig-card" style={row.style}>
                <div className="mobile-gig-card-header">
                    {row.date?.newFormat}
                    <div className="mobile-gig-card-venue">
                        {row.venue}
                    </div>
                </div>
                <div className="mobile-gig-card-act" style={{ padding: '12px 16px', borderBottom: '1px solid #eee' }}>
                    <div className="mobile-gig-card-status">{row.status}</div>
                    {row.actName}
                </div>
                <div className="mobile-gig-card-fees">
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Venue/Client Fee</span>
                        <span className="mobile-gig-fee-value">{row.gigFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Agent Fee</span>
                        <span className="mobile-gig-fee-value">{row.agentFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Performance Fee</span>
                        <span className="mobile-gig-fee-value">{row.actFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Invoice Amount</span>
                        <span className="mobile-gig-fee-value">{row.feePaidToAct}</span>
                    </div>
                </div>
                <div className="mobile-gig-card-footer">
                    <div className="mobile-gig-card-actions">
                        {row.action}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let { requests, newRequests } = this.props.bookingRequestStore;
        const { currentProfile } = this.props.profileStore;
        const { profileType } = this.props;
        const { venueId } = this.props.reportStore;
        if (venueId) {
            newRequests = newRequests.filter(x => x.venueId === venueId);
        }
        this.props.bookingRequestStore.setBookingsCount("requests", newRequests);
        return (
            <Fragment>
                <Grid container spacing={8}>
                    <Grid item xs={12} lg={12}>
                        <div>
                            <Typography variant="headline" component="h3" gutterBottom style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                Booking Requests
                                <Tooltip title={
                                    <span>
                                        {profileType === "musician"
                                            ? "These are the incoming booking requests for the acts you are managing. You need to take action on these requests."
                                            : "These are the booking requests that you have sent or one of your agents have sent."}
                                        <br /><br />
                                        <b>Tip:</b> {profileType === "musician"
                                            ? "Click 'View Details' to accept the gig, assign players and create set lists."
                                            : "Click 'View Details' to see booking details."}
                                    </span>
                                }>
                                    <HelpOutlineIcon style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} />
                                </Tooltip>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={12} className="booking-table-wrapper" style={{ position: "relative", minHeight: "200px" }}>
                        <Loading showed={this.state.isLoading} />
                        <ResponsiveTable
                            sortable={true}
                            mobileSecondaryField="venue"
                            columns={this.state.columns}
                            showToolbar={profileType !== "musician"}
                            selectable={profileType !== "musician"}
                            getCheckedRows={this.getCheckedRows}
                            customActions={this.renderTableCustomActions()}
                            mobileCardRenderer={profileType === "musician" ? this.renderMobileGigCard : profileType === "agent" ? this.renderAgentMobileGigCard : undefined}
                            rows={newRequests.map(booking => {
                                var row = {};
                                const bookingRequestUrl = booking.bookingRequestId ? `/${booking.bookingRequestId}` : "";
                                
                                row.id = booking.id;
                                row.timeStart = booking.timeStart;
                                row.timeEnd = booking.timeEnd;
                                row.loadInStart = booking.loadInStart;
                                row.loadInEnd = booking.loadInEnd;
                                row.loadInTime = booking.loadInTime;
                                row.soundCheckStart = booking.soundCheckStart;
                                row.soundCheckEnd = booking.soundCheckEnd;
                                row.soundCheckTime = booking.soundCheckTime;
                                row.notes = booking.notes;
                                row.productionNotes = booking.productionNotes;
                                row.gigRequirements = booking.gigRequirements;
                                row.agentContract = booking.agentContract;
                                row.venueId = booking.venueId;
                                row.venueName = booking.venueName || booking.venue?.profileName;
                                
                                var formattedDate = moment(booking.dateStart).format("YYYY-MM-DD")
                                
                                var status = this.getBookingStatus(booking);
                                let time = booking.timeStart.length < 8 ? `0${booking.timeStart}` : booking.timeStart;
                                let endTime = booking.timeEnd.length < 8 ? `0${booking.timeEnd}` : booking.timeEnd;
                                var finalDate= moment(formattedDate + ' ' + time)
                                row.date = {newFormat: 
                                    (
                                        <div className="gig-date-box">
                                            <div className="day-name">{booking.dateStart.format("ddd")}</div>
                                            <div className="date-number">{booking.dateStart.format("DD")}</div>
                                            <div className="month">{booking.dateStart.format("MMM YYYY")}</div>
                                            <div className="time-range">{`${moment(time, 'HH:mm:ss').format('h:mm A')} - ${moment(endTime, 'HH:mm:ss').format('h:mm A')}`}</div>
                                        </div>
                                    ), value: finalDate};
                                row.venue = (
                                    <div>
                                        <span style={{fontWeight: 600}}>{booking.venue ? booking.venue.profileName : booking.venueName}</span>
                                        <br />
                                        <small style={{color: '#888'}}>{booking.venueAddress}</small>
                                    </div>
                                );
                                // row.address = booking.venueAddress;
                                // row.agentName = booking.agentName;
                                // row.time = booking.timeStart.substring(0,5);
                                var deleteBookingAvailable = (booking.status === BookingStatusType.SentToAct.ordinal || status === "SentToAct") || (booking.status === BookingStatusType.Hold.ordinal)
                                let agentActOwner = currentProfile?.type === ProfileType.Agent.ordinal && booking.createdById !== currentProfile?.id && booking.act.actAdminId === currentProfile?.id;
                                var collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile)
                     
                                row.gigFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (booking.agentOwner?.hideVenueFees && currentProfile?.type === ProfileType.Musician.ordinal) ? <i className={"icon-eye-blocked"} /> :
                                (booking.viewOnly) || (currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices)
                                    ? <i class="far fa-eye-slash"></i>
                                    : `${currentProfile?.currencySymbol + ((profileType === "agent" || profileType === "staff") && booking.isApproved
                                        ? currencyHelper.formatMoney(collectedFee.gigFee + booking.extraGigFee, 2) 
                                        : agentActOwner ? currencyHelper.formatMoney(booking.actFee, 2)
                                        : currencyHelper.formatMoney(collectedFee.gigFee, 2))}`;
                                row.agentFee = collectedFee.agentFee
                                row.agentCommissionAmount = collectedFee.agentCommissionAmount
                                const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;
                                
                                row.actName = profileType === "musician" ? (
                                    <div>
                                        <div className="gig-act-name">
                                            <a target={"_blank"} href={`/profile/${isEntertainerBookings ? currentProfile?.id : booking.act?.id}`}>
                                                {isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : booking.act?.actName}
                                            </a>
                                        </div>
                                        {booking.act?.contactName && <div className="gig-act-contact">{booking.act?.contactName}</div>}
                                        {booking.act?.contactPhone && <div className="gig-act-contact">{booking.act?.contactPhone}</div>}
                                    </div>
                                ) : booking.status === BookingStatusType.Resent.ordinal &&
                                    (profileType === "agent" || profileType === "staff" || profileType === "venue") ? (
                                        <div>
                                            {booking.bookingRequests.map(bookingRequest => (
                                                <div>
                                                    <Link target={"_blank"} to={`/profile/${bookingRequest?.act?.id}`}>{bookingRequest.act ? bookingRequest?.act?.actName : ""}</Link>
                                                    <br />
                                                    <small>Contact: {bookingRequest?.act?.contactName}</small><br />
                                                    <small>Phone: {booking?.act?.contactPhone ? booking?.act?.contactPhone  : "-"}</small>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div>
                                            <Link target={"_blank"} to={`/profile/${booking?.act?.id}`}>{booking.act ? booking?.act?.actName : ""}</Link>
                                            <br />
                                            {booking.act && <small>Contact: {booking?.act?.contactName}</small>}<br />
                                            {booking.act && <small>Phone: {booking?.act?.contactPhone ? booking?.act?.contactPhone  : "-"}</small>}
                                        </div>
                                    );

                                   
                                row.myFee = this.props.profileType === 'musician' && currentProfile?.currencySymbol + currencyHelper.formatMoney(collectedFee.myFee, 2);
    
                                row.superFee = collectedFee.superFee
                                row.feePaidToAct = collectedFee.feePaidToAct
                                
                                row.bookingCreator = booking?.createdBy ? (booking?.createdBy?.firstName + " " +booking?.createdBy?.lastName) : ""
                                row.actFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (currentProfile?.type === ProfileType.Staff.ordinal && booking.agentOwner?.hideVenueAgencyFees) ? <i className={"icon-eye-blocked"} /> : agentActOwner ? currentProfile?.currencySymbol + currencyHelper.formatMoney(booking.actFee, 2) : currentProfile?.currencySymbol + currencyHelper.formatMoney(booking.actFee, 2);
                                
                                row.isSendBookingDetails = booking.isSendBookingDetails ? <div style={{textAlign:"center", width:"100%"}}><CheckCircle style={{ texAlign:"center",color: "green"}} /></div>  : null;
                                
                                const venueAddress = booking.venueAddress || booking.venue?.fullAddress;
                                const hasAddress = venueAddress && venueAddress.trim() !== '';
                                const directionsUrl = hasAddress ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(venueAddress)}` : '#';
                                const detailsUrl = booking.type === BookingType.Adhoc.ordinal
                                    ? `/privateBooking/${booking.id}/edit` + bookingRequestUrl
                                    : currentProfile?.type === ProfileType.Musician.ordinal
                                        ? `/musician/booking/${booking.id}/details` + bookingRequestUrl
                                        : agentActOwner
                                            ? `/musician/booking/${booking.id}/details` + bookingRequestUrl
                                            : currentProfile?.type === ProfileType.Agent.ordinal
                                                ? `/booking/${booking.id}/edit`
                                                : currentProfile?.type === ProfileType.Staff.ordinal
                                                    ? `/booking/${booking.id}/edit`
                                                    : "";
                                
                                row.action = profileType === "musician" ? (
                                        <div className="gig-actions-dropdown">
                                            <Button 
                                                className="gig-actions-dropdown-btn"
                                                onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                            >
                                                Actions <ArrowDropDownIcon />
                                            </Button>
                                            <Menu
                                                open={this.state.actionAnchor[booking.id] != null}
                                                onClose={() => this.unsetActionAchnor(booking.id)}
                                                anchorEl={this.state.actionAnchor[booking.id]}
                                            >
                                                <MenuItem onClick={() => { 
                                                    this.unsetActionAchnor(booking.id); 
                                                    process.env.REACT_APP_DISABLE_BILLING_MOBILE !== "true" ? window.open(detailsUrl, '_blank') : this.props.history.push(detailsUrl, { from: 'fromMyGigs' });
                                                }}>
                                                    <VisibilityIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    View Details
                                                </MenuItem>
                                                <MenuItem 
                                                    onClick={() => { this.unsetActionAchnor(booking.id); window.open(directionsUrl, '_blank'); }}
                                                    disabled={!hasAddress}
                                                >
                                                    <DirectionsIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    Get Directions
                                                </MenuItem>
                                            </Menu>
                                        </div>
                                    ) : profileType === "agent" ? (
                                        <div className="gig-actions-dropdown">
                                            <Button 
                                                className="gig-actions-dropdown-btn"
                                                onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                            >
                                                Actions <ArrowDropDownIcon />
                                            </Button>
                                            <Menu
                                                open={this.state.actionAnchor[booking.id] != null}
                                                onClose={() => this.unsetActionAchnor(booking.id)}
                                                anchorEl={this.state.actionAnchor[booking.id]}
                                            >
                                                <MenuItem onClick={() => { 
                                                    this.unsetActionAchnor(booking.id); 
                                                    process.env.REACT_APP_DISABLE_BILLING_MOBILE !== "true" ? window.open(detailsUrl, '_blank') : this.props.history.push(detailsUrl, { from: 'fromMyGigs' });
                                                }}>
                                                    <EditIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    View / Edit
                                                </MenuItem>
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleOpenDuplicateBookingModal(booking); }}>
                                                    <FileCopyIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    Duplicate Booking
                                                </MenuItem>
                                                {booking.status === BookingStatusType.Declined.ordinal && (
                                                    <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleOpenChangeActModal(booking); }}>
                                                        <span style={{ marginRight: 10, color: '#888', fontSize: 18 }}>↻</span>
                                                        Change Roster
                                                    </MenuItem>
                                                )}
                                                {this.isRelatedCreator(booking) && (booking.status !== BookingStatusType.Resent.ordinal && booking.status !== BookingStatusType.SentToAct.ordinal) && (
                                                    <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleOpenDeleteBookingModal(booking); }}>
                                                        <CancelIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                        Delete Booking
                                                    </MenuItem>
                                                )}
                                                {this.isRelatedCreator(booking) && (booking.status === BookingStatusType.Resent.ordinal || booking.status === BookingStatusType.SentToAct.ordinal) && (
                                                    <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleOpenCancelBookingModal(booking); }}>
                                                        <CancelIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                        Cancel Booking
                                                    </MenuItem>
                                                )}
                                                {booking.createdById === currentProfile?.id && (booking.status === BookingStatusType.SentToAct.ordinal || status === "SentToAct") && (
                                                    <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleSendReminder(booking); }}>
                                                        <span style={{ marginRight: 10, color: '#888', fontSize: 18 }}>↻</span>
                                                        Resend booking request
                                                    </MenuItem>
                                                )}
                                                {booking.createdById === currentProfile?.id && (status === BookingStatusType.Resent.ordinal || status === "Resent") && (
                                                    <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleSendReminderRequest(booking); }}>
                                                        <span style={{ marginRight: 10, color: '#888', fontSize: 18 }}>↻</span>
                                                        Resend booking request
                                                    </MenuItem>
                                                )}
                                                {booking.createdById === currentProfile?.id && (
                                                    <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.props.history.push(`/booking/${booking.id}/sendBookingEmail`); }}>
                                                        <span style={{ marginRight: 10, color: '#888', fontSize: 18 }}>✉</span>
                                                        Send Booking Details via Email
                                                    </MenuItem>
                                                )}
                                                {booking.createdById === currentProfile?.id && (
                                                    <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.props.history.push(`/booking/printBookingDetails/${booking.id}`); }}>
                                                        <PrintIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                        Print Booking Details
                                                    </MenuItem>
                                                )}
                                            </Menu>
                                        </div>
                                    ) : (
                                        <Fragment>
                                            <div className="gig-actions">
                                                <Tooltip title={hasAddress ? "Get Directions" : "No address available"}>
                                                    <span>
                                                        <Button
                                                            className="gig-action-btn"
                                                            component="a"
                                                            href={directionsUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            disabled={!hasAddress}
                                                            style={!hasAddress ? {opacity: 0.5} : {}}
                                                        >
                                                            <DirectionsIcon style={{fontSize: 18}} />
                                                        </Button>
                                                    </span>
                                                </Tooltip>
                                                <Tooltip title="View Details">
                                                    <Button
                                                        className="gig-action-btn"
                                                        component={Link}
                                                        to={detailsUrl}
                                                    >
                                                        <VisibilityIcon style={{fontSize: 18}} />
                                                    </Button>
                                                </Tooltip>
                                                <Tooltip title="More Actions">
                                                    <Button className="gig-action-btn" onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}>
                                                        <MoreHorizIcon style={{fontSize: 18}} />
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                            {booking.id && (
                                                <Menu
                                                    open={this.state.actionAnchor[booking.id] != null}
                                                    onClose={() => this.unsetActionAchnor(booking.id)}
                                                    anchorEl={this.state.actionAnchor[booking.id]}
                                                >
                                                    <MenuItem
                                                        button
                                                        className="booking-details"
                                                        onClick={() => {
                                                            let redirectUrl =
                                                                booking.type === BookingType.Adhoc.ordinal
                                                                    ? `/privateBooking/${booking.id}/edit` + bookingRequestUrl
                                                                    : currentProfile?.type === ProfileType.Musician.ordinal
                                                                        ? `/musician/booking/${booking.id}/details`
                                                                        : agentActOwner
                                                                            ? `/musician/booking/${booking.id}/details`
                                                                            : currentProfile?.type === ProfileType.Staff.ordinal
                                                                                ? `/booking/${booking.id}/edit`
                                                                                : "";
                                                             process.env.REACT_APP_DISABLE_BILLING_MOBILE !== "true" ? window.open(redirectUrl, '_blank'):                         
                                                    this.props.history.push(redirectUrl, { from: 'fromMyGigs' });
                                                        }}
                                                    >
                                                        {booking.createdById === currentProfile?.id || booking.isBookingVenueManagemenet ? "View / Edit" : "View"}
                                                    </MenuItem>
                                                   
                                                    {(booking.createdById === currentProfile?.id || booking.isBookingVenueManagemenet)? <MenuItem onClick={() => this.handleOpenDuplicateBookingModal(booking)}>Duplicate Booking</MenuItem> : null}
                                                    {(booking.createdById === currentProfile?.id || booking.isBookingVenueManagemenet) && booking.status === BookingStatusType.Declined.ordinal ? <MenuItem onClick={() => this.handleOpenChangeActModal(booking)}>Change Roster</MenuItem> : null}
                                                    {currentProfile?.type === ProfileType.Staff.ordinal && (booking.createdBy?.type === ProfileType.Staff.ordinal || booking?.activateEditVenue) && (booking.createdById === currentProfile?.id || booking.isBookingVenueManagemenet) && (booking.status != BookingStatusType.Resent.ordinal && booking.status != BookingStatusType.SentToAct.ordinal) ? <MenuItem onClick={() => this.handleOpenDeleteBookingModal(booking)}>Delete Booking</MenuItem> : null}
                                                    {currentProfile?.type === ProfileType.Staff.ordinal && (booking.createdBy?.type === ProfileType.Staff.ordinal || booking?.activateEditVenue) && (booking.createdById === currentProfile?.id || booking.isBookingVenueManagemenet) && (booking.status === BookingStatusType.Resent.ordinal || booking.status === BookingStatusType.SentToAct.ordinal) ?  <MenuItem onClick={() => this.handleOpenCancelBookingModal(booking)}>Cancel Booking</MenuItem> : null}
                                                    {(booking.createdById === currentProfile?.id || booking.isBookingVenueManagemenet) && (booking.createdBy?.type === ProfileType.Staff.ordinal || booking?.activateEditVenue) && (booking.status === BookingStatusType.SentToAct.ordinal || status === "SentToAct" ) ? <MenuItem onClick={() => this.handleSendReminder(booking)}>Resend booking request</MenuItem> : null}
                                                    {(booking.createdById === currentProfile?.id || booking.isBookingVenueManagemenet) && (booking.createdBy?.type === ProfileType.Staff.ordinal || booking?.activateEditVenue) && (status === BookingStatusType.Resent.ordinal || status === "Resent" ) ? <MenuItem onClick={() => this.handleSendReminderRequest(booking)}>Resend booking request</MenuItem> : null}
                                                </Menu>
                                            )}
                                        </Fragment>
                                    );
                                row.status = (
                                    <BookingStatusBadge
                                        cancelledBy={booking.cancelledBy ? booking.cancelledBy.type : 0}
                                        status={this.getBookingStatus(booking)}
                                    />
                                );
                                return row;
                            })}
                            // footerRow = {
                            //     currentProfile?.type === ProfileType.Agent.ordinal ? 
                            //         this.renderFooterRow() : undefined
                            // }
                        />
                    </Grid>
                    <Grid item style={{marginTop: 25}} xs={12} key="more" alignContent="center" alignItems="center" justify="center">
                        <Grid container direction="row" justify="center" alignItems="center">
                            {this.props.bookingRequestStore.showMoreRequest ? (
                                <Button variant="outlined" size="large" color="primary" onClick={this.handleShowMore}>
                                    Show More
                                </Button>
                            ) : null}
                        </Grid>
                    </Grid>
                </Grid>
                <ConfirmationModal
                    open={this.state.duplicateModalState}
                    message={`Are you sure you want to duplicate this booking - ${this.state.duplicateBooking?.title}?`}
                    closeHandler={this.handleCloseDuplicateBookingModal}
                    confirmationHandler={this.handleDupicateRequest}
                    declineHandler={this.handleCloseDuplicateBookingModal}
                    confirmationLabel="Duplicate"
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                    }}
                    open={this.state.openDuplicateSnackbar}
                    autoHideDuration={4000}
                    onClose={this.handleSnackbarEditClose}
                    SnackbarContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id">Booking {this.state.duplicateBooking?.title} duplicated</span>}
                    action={
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleSnackbarEditClose}>
                            <CloseIcon />
                        </IconButton>
                    }
                />

                <ConfirmationModal
                    open={this.state.deleteModalState}
                    title={"Delete confirmation."}
                    message={`This cannot be undone.  Would you like to delete this booking?`}
                    closeHandler={this.handleCloseDeleteBookingModal}
                    confirmationHandler={this.handleDeleteRequest}
                    declineHandler={this.handleCloseDeleteBookingModal}
                    confirmationLabel="Delete"
                />
                <ConfirmationModal
                    open={this.state.cancelModalState}
                    title={"Cancel confirmation."}
                    message={`This cannot be undone.  Would you like to cancel this booking?`}
                    closeHandler={this.handleCloseCancelBookingModal}
                    confirmationHandler={this.handleCancelBooking}
                    declineHandler={this.handleCloseCancelBookingModal}
                    confirmationLabel="Cancel"
                />

                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                    }}
                    open={this.state.openDeleteSnackbar}
                    autoHideDuration={4000}
                    onClose={this.handleSnackbarDeleteClose}
                    SnackbarContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id">Booking {this.state.deleteBooking?.title} deleted</span>}
                    action={
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleSnackbarEditClose}>
                            <CloseIcon />
                        </IconButton>
                    }
                />
                <BookingChangeActModal open={this.state.changeActModalState} onCloseModel={this.handleCloseChangeActModalWithoutAction} onClose={this.handleCloseChangeActModal} booking={this.state.booking} />
                <BulkEditModal
                    open={this.state.bulkEditModalOpen}
                    onClose={this.closeBulkEditModal}
                    selectedBookings={this.state.selectedBookings.map(row => this.props.bookingRequestStore.newRequests.find(b => b.id === row.id)).filter(b => b && this.isRelatedCreator(b))}
                    onSubmit={this.handleBulkEditSubmit}
                />
                <BulkCancelModal
                    open={this.state.bulkCancelModalOpen}
                    onClose={this.closeBulkCancelModal}
                    selectedBookings={this.state.selectedBookings.map(row => this.props.bookingRequestStore.newRequests.find(b => b.id === row.id)).filter(b => b && this.isRelatedCreator(b))}
                    onComplete={this.handleBulkCancelComplete}
                />
            </Fragment>
        );
    }
}

export default BookingRequests;
